import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "statusContainer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "iconTitle" }
const _hoisted_4 = { class: "ctaLink rte" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "inner" }
const _hoisted_7 = { class: "printOnly" }
const _hoisted_8 = { class: "printHeader" }
const _hoisted_9 = { class: "date" }
const _hoisted_10 = { class: "col1" }
const _hoisted_11 = { class: "desktop h2" }
const _hoisted_12 = {
  key: 0,
  class: "mobile editInput"
}
const _hoisted_13 = {
  key: 1,
  class: "mobile fareInfo"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 2,
  class: "content"
}
const _hoisted_16 = {
  key: 0,
  class: "downloadTimetables mobile"
}
const _hoisted_17 = { class: "col2" }
const _hoisted_18 = {
  key: 2,
  class: "routeInformation"
}
const _hoisted_19 = {
  key: 3,
  class: "downloadTimetables desktop"
}
const _hoisted_20 = { class: "printOnly" }
const _hoisted_21 = { key: 0 }

import {
  PortList,
  TimetableSearch,
  EditTimetableInput,
  ExploreMapButton,
  BuyTicketBanner,
  Icon,
  RouteSearchMap,
  TimetableRouteInfo,
  BuyTicketSticky,
  DownloadTimetableBlock,
  TimetableResultView,
  LatLng,
} from '@components';
import {
  useRoutesStore,
  useOfflineTimetableStore,
  useTimetableStore,
} from '@components/store';
import {
  OfflineTimetablesResult,
  OfflineTimetableType,
} from '@components/apiTypes';
import {
  format, isToday, isValid, parseISO,
} from 'date-fns';
import {
  formatInTimeZone,
} from 'date-fns-tz';
import vClickOutside from '@venegrad/vue3-click-outside';
import {
  computed,
  onMounted, onUnmounted, ref, watch, watchEffect,
} from 'vue';
import { TABLET_VIEWPORT_WIDTH } from '@components/config';
import { RouteInformation, Sailings } from '@components/types/api';
import { utcDate } from '@components/helpers';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import config from '@/config';
import router from '@/router';
import { ticketingUrl, routeInformationUrl, timezone } from '../../envVariables';
import TimetableAlertOverlay from '../Overlay/TimetableAlertOverlay.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimetableSearchResult',
  props: {
    from: {},
    to: {},
    departureDate: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const routeStore = useRoutesStore();
const offlineTimetableStore = useOfflineTimetableStore();
const timetableStore = useTimetableStore();

const vueRouter = useRouter();

const downloadTimetableItems = ref<Array<OfflineTimetablesResult> | undefined>(offlineTimetableStore
  .getOfflineTimetables);
const reinitDatepickerCarousel = ref(false);

const routeInformation = ref<RouteInformation|undefined>(routeStore.firstRoutesByPorts);
const routeCode = ref<string>(routeInformation.value?.routeCode ?? '');
const routeMapData = ref(routeStore.getMapRoutesByPortName);
const portsMapData = ref(routeStore.getMapPortsByPortName);
const centreMapData = ref<LatLng>();

const isMapVisible = ref(false);
const { mapPlaceholderImage } = config;

const toggleMapVisibility = () => {
  isMapVisible.value = !isMapVisible.value;
};

const sailingResults = ref<Array<Sailings>>();

const isLoading = ref<boolean>(false);

const viewState = ref({
  search: {
    from: decodeURI(props.from),
    to: decodeURI(props.to),
    fromDate: isValid(parseISO(props.departureDate))
      ? props.departureDate : utcDate(new Date()).toISOString(),
  },
});

const showTimetableInput = ref(false);

const showAlertModal = ref(false);

const isMobileScreenWidth = window.innerWidth < TABLET_VIEWPORT_WIDTH;

centreMapData.value = { lat: 55.609867, lng: -4.958157 };

const routeToNewDate = (
  fromInput: string,
  toInput: string,
  newDate: string,
) => {
  router.push({
    name: 'timetableResult',
    params: {
      from: encodeURI(fromInput),
      to: encodeURI(toInput),
      departureDate: formatInTimeZone(parseISO(newDate), timezone, 'yyyy-MM-dd'),
    },
  });
};

const routeInfoUrl = computed(() => {
  const infoText = t('Information').toLowerCase();
  return `${routeInformationUrl}/${routeCode.value}/#${infoText}`;
});

const updateSearchValues = async (
  fromInput: string,
  toInput: string,
  newDate: string,
  reinitSwiper = false,
) => {
  if (!isValid(parseISO(newDate))) {
    return;
  }

  const { from, to } = viewState.value.search;

  if (from !== fromInput || to !== toInput) {
    await routeStore.requestRouteByPorts(fromInput, toInput);
    await offlineTimetableStore.requestOfflineTimetables(fromInput, toInput);

    viewState.value.search = {
      ...viewState.value.search,
      from: fromInput ?? props.from,
      to: toInput ?? props.to,
    };
  }

  viewState.value.search.fromDate = newDate;

  reinitDatepickerCarousel.value = reinitSwiper;
  showTimetableInput.value = false;

  await timetableStore.getSearchResults(viewState.value.search);
};

const printDocument = () => window.print();

const getTimetableBlockIcon = (timetableType) => {
  switch (timetableType) {
    case OfflineTimetableType.Summer:
      return 'summerTimetable';
    case OfflineTimetableType.Tidal:
      return 'tidalTimetable';
    default:
      return 'winterTimetable';
  }
};

const routeToRouteItem = () => {
  vueRouter.push({
    name: 'serviceStatusItem',
    params: {
      routeCode: routeCode.value,
      tab: t('Sailings').toLowerCase(),
    },
  });
};

const displayAlertModal = () => {
  showAlertModal.value = true;
  document.querySelector('html')?.classList.add('stopScroll');
  document.querySelector('body')?.classList.add('darkOverlay');
};

const closeModal = () => {
  showAlertModal.value = false;
  document.querySelector('html')?.classList.remove('stopScroll');
  document.querySelector('body')?.classList.remove('darkOverlay');

  // Reset focus and remove tabindex
  const defaultEl = document.querySelector('.alertCard') as HTMLElement | null;
  const overlay = document.querySelector('.timetableAlertOverlay') as HTMLElement | null;
  overlay?.removeAttribute('tabindex');
  if (defaultEl) defaultEl.focus();
};

const handleKeyPress = (event: KeyboardEvent) => {
  const overlay = document.querySelector('.timetableAlertOverlay') as HTMLElement | null;
  if (!overlay?.classList.value.includes('panelActive')) return;

  if (event.key === 'Escape') {
    closeModal();
    return;
  }

  if (event.key !== 'Tab') return;

  const buttons = overlay.querySelectorAll('.closeBtn, .routeInfoBtn, .serviceStatusBtn') as unknown as HTMLElement[];
  if (buttons.length === 0) return;

  const tabIndexAttr = overlay.getAttribute('tabindex');
  const hasTabIndex = tabIndexAttr !== null;
  const tabIndex = hasTabIndex ? parseInt(tabIndexAttr ?? '-1', 10) : -1;

  event.preventDefault();

  // First tab press → focus closeBtn
  if (!hasTabIndex || tabIndex === -1) {
    overlay.setAttribute('tabindex', '0');
    buttons[0].focus();
    return;
  }

  const direction = event.shiftKey ? -1 : 1;
  const nextIndex = (tabIndex + direction + buttons.length) % buttons.length;

  overlay.setAttribute('tabindex', nextIndex.toString());
  buttons[nextIndex].focus();
};

const handleModalButtonClick = (linkText: string) => {
  if (linkText === routeInformation.value?.timetableServiceStatusLinkText) {
    routeToRouteItem();
  } else if (linkText === routeInformation.value?.routeInformationLinkText) {
    window.location.href = `${routeInformationUrl}/${routeInformation.value?.routeCode}`;
  }

  closeModal();
};

watch(() => showAlertModal.value, () => {
  if (showAlertModal.value) {
    document.addEventListener('keydown', handleKeyPress);
  } else {
    document.removeEventListener('keydown', handleKeyPress);
  }
});

watchEffect(() => {
  isLoading.value = routeStore.isLoading;
});

watchEffect(() => {
  routeInformation.value = routeStore.firstRoutesByPorts;
  routeCode.value = routeInformation.value?.routeCode ?? '';
  routeMapData.value = routeStore.getMapRoutesByPortName;
  portsMapData.value = routeStore.getMapPortsByPortName;
});

watchEffect(() => {
  if (offlineTimetableStore.getOfflineTimetables) {
    downloadTimetableItems.value = offlineTimetableStore.getOfflineTimetables;
  }
});

watch(() => router.currentRoute.value, (watchedRoute) => {
  if (!isValid(parseISO(watchedRoute.params.departureDate.toString()))) {
    return;
  }
  if (watchedRoute.params.from && watchedRoute.params.to && watchedRoute.params.departureDate) {
    updateSearchValues(
      decodeURI(watchedRoute.params.from.toString()) ?? props.from,
      decodeURI(watchedRoute.params.to.toString()) ?? props.to,
      parseISO(`${watchedRoute.params.departureDate.toString()}Z`).toISOString(),
      true,
    );
  }
});

onMounted(async () => {
  document.querySelector('html')?.classList.add('removeOverflow');
  document.querySelector('body')?.classList.add('removeOverflow');

  await timetableStore.getSearchResults(viewState.value.search);
  await routeStore.requestRouteByPorts(viewState.value.search.from, viewState.value.search.to);
  await offlineTimetableStore.requestOfflineTimetables(
    viewState.value.search.from,
    viewState.value.search.to,
  );
});

onUnmounted(() => {
  document.querySelector('html')?.classList.remove('removeOverflow');
  document.querySelector('body')?.classList.remove('removeOverflow');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Icon), { "icon-name": "boat" }),
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t('Route status banner text')) + " ", 1),
            _createElementVNode("button", {
              class: "routeItemBtn",
              role: "link",
              onClick: routeToRouteItem
            }, _toDisplayString(_ctx.$t('Route status banner link text')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["timetableSearchResults", { 'searchError' : _unref(timetableStore).isServerError }])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(Icon), { "icon-name": "calmacLogo" }),
              _createElementVNode("h1", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('Calmac name')) + " ", 1),
                _createElementVNode("small", null, _toDisplayString(_ctx.$t('Calmac description')), 1)
              ])
            ]),
            _createVNode(_unref(PortList), {
              ports: [{name: viewState.value.search.from}, {name: viewState.value.search.to}]
            }, null, 8, ["ports"]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(Icon), { "icon-name": "calendar" }),
              _createElementVNode("span", null, _toDisplayString(_unref(isToday)(new Date(viewState.value.search.fromDate))
                ? `Today: ${_unref(format)(new Date(viewState.value.search.fromDate), 'EEEE, d LLLL y')}`
                : _unref(format)(new Date(viewState.value.search.fromDate), 'EEEE, d LLLL y')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.$t('Timetable Search')), 1),
            _createVNode(_unref(TimetableSearch), {
              class: _normalizeClass(["timetableSearch", {showTimetableInput: showTimetableInput.value}]),
              "button-text": _ctx.$t('Search timetable'),
              from: decodeURI(_ctx.from),
              to: decodeURI(_ctx.to),
              "initial-date": _ctx.departureDate,
              onTimetableSearchClick: _cache[0] || (_cache[0] = (
              fromInput,
              toInput,
              newDate
            ) =>
              routeToNewDate(fromInput, toInput, newDate))
            }, null, 8, ["class", "button-text", "from", "to", "initial-date"]),
            (!showTimetableInput.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_unref(EditTimetableInput), {
                    ports: [{name: viewState.value.search.from}, {name: viewState.value.search.to}],
                    "toggle-input": () => showTimetableInput.value = true
                  }, null, 8, ["ports", "toggle-input"])
                ]))
              : _createCommentVNode("", true),
            (routeCode.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("a", {
                    class: "ctaLink",
                    href: routeInfoUrl.value
                  }, [
                    _createVNode(_unref(Icon), { "icon-name": "info" }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('Route and fare information')), 1)
                  ], 8, _hoisted_14)
                ]))
              : _createCommentVNode("", true),
            (!_unref(timetableStore).isServerError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_unref(TimetableResultView), {
                    from: viewState.value.search.from,
                    to: viewState.value.search.to,
                    "from-date": viewState.value.search.fromDate,
                    "reinit-datepicker-carousel": reinitDatepickerCarousel.value,
                    "is-web-view": true,
                    onToggleSwiper: _cache[1] || (_cache[1] = (isInit) => reinitDatepickerCarousel.value = isInit),
                    onUpdateSearchResults: _cache[2] || (_cache[2] = (newDate) => routeToNewDate(
                viewState.value.search.from,
                viewState.value.search.to,
                newDate
              )),
                    onGetSailingResults: _cache[3] || (_cache[3] = (sailings) => sailingResults.value = sailings)
                  }, null, 8, ["from", "to", "from-date", "reinit-datepicker-carousel"]),
                  (downloadTimetableItems.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(downloadTimetableItems.value, (timetable, index) => {
                          return (_openBlock(), _createBlock(_unref(DownloadTimetableBlock), {
                            key: index,
                            title: timetable.title,
                            "icon-name": getTimetableBlockIcon(timetable.timetableType),
                            ports: [{name: _ctx.from}, {name: _ctx.to}],
                            text: timetable.releaseDetail,
                            "download-link": timetable.pdfUrl
                          }, null, 8, ["title", "icon-name", "ports", "text", "download-link"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(BuyTicketBanner), {
                    "image-src": require('../../../Images/buyButtonBanner.png'),
                    "image-alt": _ctx.$t('Buy ticket image alt'),
                    "link-text": _ctx.$t('Buy tickets'),
                    title: _ctx.$t('Buy your tickets online'),
                    link: _unref(ticketingUrl)
                  }, null, 8, ["image-src", "image-alt", "link-text", "title", "link"]),
                  (sailingResults.value && sailingResults.value.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "print",
                        onClick: printDocument
                      }, [
                        _createVNode(_unref(Icon), { "icon-name": "print" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Print timetable')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(BuyTicketSticky), {
                    text: _ctx.$t('Buy your tickets online'),
                    "link-text": ('Buy tickets'),
                    link: _unref(ticketingUrl),
                    "alert-title": routeInformation.value?.timetableTitle,
                    "alert-warning-type": routeInformation.value?.timetableWarningType,
                    "show-alert": routeInformation.value?.isTimetableWarningEnabled,
                    "on-click-alert": () => displayAlertModal()
                  }, null, 8, ["text", "link", "alert-title", "alert-warning-type", "show-alert", "on-click-alert"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            (!isMapVisible.value)
              ? (_openBlock(), _createBlock(_unref(ExploreMapButton), {
                  key: 0,
                  "on-click": toggleMapVisibility,
                  "has-placeholder-image": true,
                  "image-src": _unref(mapPlaceholderImage),
                  "image-alt": _ctx.$t('Map placeholder image alt')
                }, null, 8, ["image-src", "image-alt"]))
              : _createCommentVNode("", true),
            (isMapVisible.value && routeMapData.value && portsMapData.value && centreMapData.value)
              ? (_openBlock(), _createBlock(_unref(RouteSearchMap), {
                  key: 1,
                  center: centreMapData.value,
                  ports: portsMapData.value,
                  routes: routeMapData.value,
                  "is-status-map": false
                }, null, 8, ["center", "ports", "routes"]))
              : _createCommentVNode("", true),
            (routeInformation.value && routeInformation.value.routeInformation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Route information')), 1),
                  _createVNode(_unref(TimetableRouteInfo), {
                    "route-info": routeInformation.value.routeInformation,
                    "show-more-info-link": true,
                    "more-info-link-text": _ctx.$t('More information'),
                    "more-info-link": routeInfoUrl.value,
                    "is-loading": isLoading.value
                  }, null, 8, ["route-info", "more-info-link-text", "more-info-link", "is-loading"])
                ]))
              : _createCommentVNode("", true),
            (downloadTimetableItems.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(downloadTimetableItems.value, (timetable, index) => {
                    return (_openBlock(), _createBlock(_unref(DownloadTimetableBlock), {
                      key: index,
                      title: timetable.title,
                      "icon-name": getTimetableBlockIcon(timetable.timetableType),
                      ports: [{name: _ctx.from}, {name: _ctx.to}],
                      text: timetable.releaseDetail,
                      "download-link": timetable.pdfUrl
                    }, null, 8, ["title", "icon-name", "ports", "text", "download-link"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("footer", _hoisted_20, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('Copyright text')), 1)
        ])
      ])
    ], 2),
    (routeInformation.value?.isTimetableWarningEnabled)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(TimetableAlertOverlay, {
            "is-open": showAlertModal.value,
            "is-mobile": isMobileScreenWidth,
            "close-callback": closeModal,
            title: routeInformation.value.timetableTitle ?? '',
            text: routeInformation.value.timetableText ?? '',
            "service-status-link-text": routeInformation.value.timetableServiceStatusLinkText,
            "route-information-link-text": routeInformation.value.routeInformationLinkText,
            "redirect-callback": handleModalButtonClick
          }, null, 8, ["is-open", "title", "text", "service-status-link-text", "route-information-link-text"])
        ])), [
          [_unref(vClickOutside), (e) => e.target.className.includes('darkOverlay') && closeModal()]
        ])
      : _createCommentVNode("", true)
  ], 64))
}
}

})